import { TableColumn } from "react-data-table-component";
import { FormGroup, Input } from "reactstrap";
import { IConfig, ISetting } from "src/services/types";

export const columnsSettings: (
    config: IConfig, 
    onActive: (item: ISetting) => void,
    onEdit: (item: ISetting) => void
) => TableColumn<ISetting>[] = 
(config, onActive, onEdit) => {
      
    return (
[
    { 
      name: "N°",
      width: "100px",
      selector: (_, index, ) => (config.page-1)*config.per_page + (index! + 1),
    },
    {
        name: "SETTING TYPE",
        width: "200px",
        selector: (row: ISetting) => row.settingTypeName,
    },
    {
      name: "TEXT",
      width: "200px",
      selector: (row: ISetting) => row?.text,
    },
    {
      name: "ACTIVE",
      width: "150px",
      center: true,
      cell: function OrderItems(item) {
        return (
            <FormGroup switch>
                <Input
                    type="switch"
                    checked={item?.active}
                    onChange={() => {onActive(item)}}
                />
            </FormGroup>
        );
      }
    },
    {
        name: "EDIT",
        width: "100px",
        cell: function OrderItems(item) {
            return (
                <button
                    type="button"
                    className="btn btn-soft-primary btn-sm waves-effect waves-light"
                    onClick={() => onEdit(item)}
                >
                    <i className="fas fa-edit"></i>
                </button>
            );
        },
    },
  ]
)}